import { api } from '../api'
import { prepareQueryParams } from '@homeviews/utils'

export const activityLogsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getLogs: builder.query({
      query: (params) => ({
        url: `${
          process.env.NX_API_BASE_URL_PREFIX
        }/api/developer-portal/logs${prepareQueryParams(params)}`,
        method: 'GET',
      }),
    }),
  }),
})

export const { useGetLogsQuery } = activityLogsApi
